import { TextField, TextFieldProps } from '@mui/material'
import { memo } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

export type ExtraSmallTextFieldProps = {
    textFieldProps: TextFieldProps,
    views?: any[],
    hideEndIcon?: boolean
}
const ExtraSmallTextField = ({ textFieldProps, views, hideEndIcon }: ExtraSmallTextFieldProps) => {
    return (
        <TextField {...textFieldProps}
                   inputProps={{
                       ...textFieldProps.inputProps,
                       sx: { ...(textFieldProps.inputProps?.sx ?? {}), padding: '0 !important', textAlign: 'center', fontSize: 12 }
                   }}
                   InputProps={{
                       ...textFieldProps.InputProps,
                       sx: {
                           px: 0.25,
                           py: 0.2,
                           height: 24,
                           '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                               display: 'none'
                           },
                           '& input[type=number]': {
                               MozAppearance: 'textfield'
                           }
                       }
                   }}
                   sx={{ ...textFieldProps.sx }}
                   SelectProps={{
                       ...textFieldProps.SelectProps,
                       sx: {
                           height: 24,
                           maxWidth: '100%',
                           '& .MuiSvgIcon-root': {
                               display: 'inlinBlock',
                               vertAlign: 'center',
                               width: 20,
                               height: 20
                           },
                           '.MuiSelect-select': {
                               pl: 0.5,
                               pr: '0 !important',
                               py: 0.1,
                               fontSize: 12,
                               maxWidth: '100%',
                               textOverflow: 'ellipsis',
                               whiteSpace: 'nowrap',
                               overflow: 'hidden'
                           }
                       },
                       IconComponent: hideEndIcon ? undefined : () => <ArrowDropDownIcon
                           sx={{ width: 20, height: 20 }} />

                   }}
        >
            {
                (views ?? []).map((view) => (view))
            }
        </TextField>
    )
}

export default memo(ExtraSmallTextField)

